import Slide from './slide';


class ImageSlide extends Slide {

    constructor({
		root,
		element,
		autoload = false,
		defaultDuration = 1,
		slideImageAttribute = 'slideImage'
	}) {
		super({root: root, element: element, type: 'image', autoload: autoload, defaultDuration: defaultDuration});
		this.image = null;
		this.slideImageAttribute = slideImageAttribute;
    }


    getImage() {
		if (!this.image) {
			this.image = this.slideImageAttribute ?
				this.getComponent(this.element.querySelector(this.dataSelector(this.slideImageAttribute))) :
				this.getComponent('AsyncPicture')
			;
		}
		return this.image;
	}


    load() {
		const image = this.getImage();
		if (!image) {
			return super.load();
		}
		if (!this.loading && !this.loaded) {
			this.loading = true;
			image.load().then(() => {
				this.loaded = true;
				this.closeAsyncEvent('load');
				if (this.element) {
					this.events.trigger(this.element, 'slide:load', {component: this});
				}
				this.loading = false;
			});
		}
		this.events.trigger(this.element, 'resize', {component: this});
		return this.on('load');
    }


}

export default ImageSlide;
